import { useAtomValue } from 'jotai';
import { user_atom } from 'customJotai/atom';
import { memo, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import useMessage from 'antd/es/message/useMessage';
import history from '@shared/browserHistory';

export const AuthProvider = memo(function AuthProvider() {
  const url = history.location.pathname;
  const user = useAtomValue(user_atom);
  const [messageApi, context] = useMessage({ maxCount: 1 });
  useEffect(() => {
    if (!user && url !== '/login') {
      messageApi.error({
        type: 'error',
        content: 'ログインセッションが切れました',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (!user) {
    return (
      <>
        {context}
        <Redirect to='/login' />
      </>
    );
  }
  return null;
});
